<div class="section-title section-title--about">
    <h2>
        SERVICE LEVEL UPDATE
    </h2>
</div>
<div class="content">
    <section class="culture">
        <div class="culture__text highfont-p">
            <p>
                Effective September 2, 2026, SGC will be adjusting its offered service levels in response to rapidly increasing demand and continued expansion of estimated turnaround times. Please visit our standard services and pricing page for the full breakdown: <a routerLink="/card-grading/services-pricing">https://www.gosgc.com/card-grading/services-pricing</a>.
            </p>

            <img src="/assets/img/202608NewPricesArticle.jpg" width="100%" alt="Service Level Update" title="Service Level Update" style="align-items:center;width:70%;margin-left:15%;margin-right:15%; ">

            <p>
                SGC’s mission has always been to provide consistent and accurate grading in a timely manner, and while our team’s emphasis on quality and expertise has never been stronger, turnaround times have increased beyond acceptable levels.
            </p>
            <p>
                While this measure may be disappointing in the short term, rest assured that we are not standing still, and the steps we are taking are significant. We are aggressively hiring to grow our team, substantially expanding our operational square footage, and investing in new technology and infrastructure, all with one goal in mind: getting your cards back to you faster without sacrificing the quality and accuracy you expect from SGC.
            </p>
            <p>
                Future adjustments to service levels should be expected between late 2026 and early 2027. We will periodically release updates providing a look into our progress, our future plans and any other necessary information regarding submissions currently in our care.
            </p>
            <p>
                Servicing our hobby’s essential authentication and grading needs is something we do not take lightly. Thank you for trusting us with your cards and we look forward to what the future holds.
            </p>
        </div>
    </section>
</div>
